import {
  GetRecordingByIdArgs as ApiGetRecordingByIdArgs,
  GetRecordingsArgs as ApiGetRecordingsArgs,
  Recording,
  UpdateRecordingOptions,
} from '@sparemin/api-sdk';
import { IApiAction, IApiResponse } from '../types';

type ActionKey = 'RECORDING_SERVICE';
export const ACTION_KEY: ActionKey = 'RECORDING_SERVICE';

export enum ServiceMethod {
  UPDATE_RECORDING = 'UPDATE_RECORDING',
  RECORDING_BY_ID_GET = 'RECORDING_BY_ID_GET',
  GET_RECORDINGS = 'RECORDINGS_GET',
}

export interface NormalizedRecordingResult {
  entities: {
    recordings: Recording;
  };
  result: number;
}

export type NormalizedRecordingsResult = {
  entities: {
    recordings: { [id: number]: Recording };
  };
  result: number[];
};

export type UpdateRecordingArgs = [
  UpdateRecordingOptions['recordingId'],
  UpdateRecordingOptions['published'],
];
export type UpdateRecordingResult = void;

export type GetRecordingByIdArgs = [ApiGetRecordingByIdArgs['recordingId']];
export type GetRecordingByIdResult = NormalizedRecordingResult;

export type GetRecordingsArgs = [ApiGetRecordingsArgs['recordingIds']];
export type GetRecordingsResult = NormalizedRecordingsResult;

export type IHandle = (
  method: ServiceMethod,
  args: any,
  token?: string,
) => Promise<any>;

type ApiAction<M extends ServiceMethod, A> = IApiAction<ActionKey, M, A>;

export type UpdateRecordingAction = ApiAction<
  ServiceMethod.UPDATE_RECORDING,
  UpdateRecordingArgs
>;

export type GetRecordingByIdAction = ApiAction<
  ServiceMethod.RECORDING_BY_ID_GET,
  GetRecordingByIdArgs
>;

export type GetRecordingsAction = ApiAction<
  ServiceMethod.GET_RECORDINGS,
  GetRecordingsArgs
>;

export interface RecordingServiceDispatch {
  (action: UpdateRecordingAction): Promise<IApiResponse<UpdateRecordingResult>>;
  (action: GetRecordingByIdAction): Promise<
    IApiResponse<GetRecordingByIdResult>
  >;
  (action: GetRecordingsAction): Promise<IApiResponse<GetRecordingsResult>>;
}
